module.exports = __webpack_public_path__ + "img/752.21c6b94d.png";